export enum ProductStagesEnums{
    B2B = "B2B",
    B2C = "B2C"
}

export enum ProductStagesValuesEnums{
    B2B = "b2b",
    B2C = "b2c"
}